/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Läser in...',
	'dlg_close': 'Stäng',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Avbryt',
	'dlg_back': 'Gå tillbaka',
	'dlg_done': 'Klart',
	'dlg_save': 'Spara',

	// Slider
	'sliderRegionLabel': 'Skjutreglage - använd höger- och vänsterpilarna för att flytta skjutreglagehandtagen',
	'sliderHandleLabel': 'Skjutreglagehandtag',
	'a11ySliderHandleLabel': 'Skjutreglagehandtag %{sliderValue}',
	'sliderInputLabel': 'värde',

	// Side bar
	'sidebarAdd': 'Lägg till',
	'clearTextFilterValue': 'Rensa',
	'missingDataSetData': 'Data för den här datamängden är inte tillgängliga. Uppdatera datamängden eller be administratören om åtkomst till källan.',

	// Toolbar
	'toolbarRegionLabel': 'Verktygsfält',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Teckenfamilj',
	'fontFamilyStyle': 'Teckenformat',
	'regularFontStyle': 'Normal',
	'fontSizeSelect': 'Teckenstorlek',
	'fontColorSelect': 'Färg',
	'fontStyle': 'Format',
	'colorPickerTitle': 'Välj en färg',
	'bold': 'Halvfet',
	'italic': 'Kursiv',
	'underline': 'Understrykning',
	'fontAlignment': 'Justering',
	'justifyLeft': 'Justera åt vänster',
	'justifyCenter': 'Centrera',
	'justifyRight': 'Justera åt höger',
	'insertOrderedList': 'Numrerad lista',
	'insertUnorderedList': 'Onumrerad lista',
	'fontColorPicker': 'Färgväljare',
	'textWrap': 'Radbryt text',
	'restore': 'Återställ till standardvärden',
	'textAutoFontSize': 'Auto',
	'textDefaultFontSize': 'Standard',
	'textItemTitle': 'Titel',
	'textLabelShadow': 'Etikettskugga',
	'textContrastLabelColor':'Kontrastfärg',
	'toggleOn': 'På',
	'toggleOff': 'Av',
	'contrastLabelColorInfo': 'Automatisk justering av etikettfärg för tillgänglighet. Det här åsidosätter teckensnittsfärgen.',
	'labelShadowInfo':'Lägg till skugga till text för tillgänglighet.',
	'applyToAll':'Tillämpa styling på alla axlar',

	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Antal resultat (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Procent (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'Alternativ för högsta eller lägsta',
	'topbottomOptionLabel': 'Visa',
	'searchByLabel': 'Efter',
	'searchNoMatches': 'Inga träffar hittades',
	'topbottomRankColumnLabel': 'Lägg till rangordningskolumn i tabellen',
	'topbottomNone': 'Inget',
	'topCount': 'Antal högsta',
	'topPercent': 'Högsta %',
	'bottomCount': 'Antal lägsta',
	'bottomPercent': 'Lägsta %',
	'searchColumn': 'Sök en kolumn',
	'searchColumnAriaLabel': 'Sök en kolumn. Skriv namnet på kolumnen du vill söka efter och klicka på nedåtpilen för att söka efter kolumnen i listan.',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Rangordna (%{columnLabel})',
	'topbottomClearLabel': 'Återställ',

	// Format
	'formatAuto': 'Auto',
	'formatConvertPercent': 'Konvertera decimal till procent',
	'formatAbbreviate': 'Avrunda',
	'formatUseGrouping': 'Använd tusentalsavgränsare',
	'dateStyle': 'Datumformat',
	'dateTimeStyle': 'Datum-/tidsformat',
	'formatMissingValueCharactersInfo': 'Tecken vid saknat värde anger vilka tecken som ska visas när värdet saknas.',
	'currencySymbolLabel': 'Valutasymbol',
	'customSymbolPlaceholder': 'Lägg till en symbol',
	'customSymbolLabelInfo': 'Anger ett eller flera tecken att användas som anpassad symbol. Den här symbolen anges före talet och eventuella tecken.',
	'numberLabel': 'Nummeretikett',
	'numberPositionLabel': 'Etikettposition',
	'negativeSignPosition': 'Symbol för negativt tecken',
	'negativeSign': 'Symbol för negativt tecken',
	'numberLabelInfo': 'Anger en etikett för det formaterade numret och placeras som prefix eller suffix beroende på etikettpositionen.',
	'nullValueDefault': '<standard>',
	'nullValueContent': '(inget värde)',
	'default': 'Standard',
	'beginning': 'Början',
	'end': 'Slut',
	'formatLabel': 'Välj ett format',

	// More data indicator
	'moreDataIndicator': 'Data klipptes av vid %{threshold} objekt. Tillämpa ett filter för att visa färre.',

	// Expanded View / Focus mode
	'evCollapse': 'Komprimera',
	'duplicate': 'Kopiera',
	'copyOf': 'Kopia av %{name}',
	'unableToDuplicateBoard': 'Det går inte att kopiera "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'Det går inte att läsa in objekten.',

	// Custom widgets
	'customWidget': 'Anpassad widget',

	// Auto group
	'group': 'Grupp',

	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Hårfin',
	'textFontFamilySubClassThin': 'Tunn',
	'textFontFamilySubClassThinItalic': 'Tunn kursiv',
	'textFontFamilySubClassExtraLight': 'Extrasmal',
	'textFontFamilySubClassExtraLightItalic': 'Extrasmal kursiv',
	'textFontFamilySubClassLight': 'Smal',
	'textFontFamilySubClassLightItalic': 'Smal kursiv',
	'textFontFamilySubClassRegular': 'Normal',
	'textFontFamilySubClassRegularItalic': 'Normal kursiv',
	'textFontFamilySubClassItalic': 'Kursiv',
	'textFontFamilySubClassMedium': 'Medel',
	'textFontFamilySubClassMediumItalic': 'Medel kursiv',
	'textFontFamilySubClassHeavy': 'Tjock',
	'textFontFamilySubClassHeavyItalic': 'Tjock kursiv',
	'textFontFamilySubClassDemiBold': 'Demifet',
	'textFontFamilySubClassDemiBoldItalic': 'Demifet kursiv',
	'textFontFamilySubClassBold': 'Halvfet',
	'textFontFamilySubClassBoldItalic': 'Halvfet kursiv',
	'textFontFamilySubClassExtraBold': 'Extrafet',
	'textFontFamilySubClassExtraBoldItalic': 'Extrafet kursiv',
	'textFontFamilySubClassBlack': 'Svart',
	'textFontFamilySubClassBlackItalic': 'Svart kursiv',
	'textFontFamilySubClassStencil': 'Stencil',
	// END: Remove FontFamilySubClass
});
